import styled from 'styled-components';

export const StyledFetchElasticSearchLogsPresentation = styled.div`
  h2 {
    color: red;
  }
  h3 {
    color: green;
  }
`;

export const StyledTextInputTime = styled.input`
  border-radius: 8px;
  margin-bottom: 3px;
  margin-right: 4px;
  border: 1px solid #d2d2d1;
  padding: 0.2em;
`;

export const StyledDiv = styled.div`
  * {
    box-sizing: border-box;
  }
`;

export const StyledTimeline = styled.div`
  position: relative;
  max-width: 1200px;
  margin: 0 auto;

  &::after {
    content: '';
    position: absolute;
    width: 4px;
    background-color: blue;
    top: 0;
    bottom: 0;
    left: 50%;
    margin-left: -3px;
  }

  @media screen and (max-width: 600px) {
    &::after {
      left: 31px;
    }
  }
`;

export const StyledContainer = styled.div<{ position: 'left' | 'right' }>`
  padding: 10px 40px;
  position: relative;
  background-color: inherit;
  width: 50%;
  left: ${(props) => (props.position === 'left' ? '0' : '50%')};

  &::after {
    content: '';
    position: absolute;
    width: 15px;
    height: 15px;
    background-color: white;
    border: 4px solid blue;
    top: 15px;
    border-radius: 50%;
    z-index: 1;

    ${(props) => (props.position === 'left' ? 'right: -10px;' : 'left: -12px;')}
  }

  &::before {
    content: ' ';
    height: 0;
    position: absolute;
    top: 22px;
    width: 0;
    z-index: 1;
    ${(props) =>
      props.position === 'left'
        ? `
          right: 30px;
          border: medium solid white;
          border-width: 10px 0 10px 10px;
          border-color: transparent transparent transparent white;
        `
        : `
          left: 30px;
          border: medium solid white;
          border-width: 10px 10px 10px 0;
          border-color: transparent white transparent transparent;
        `}
  }

  @media screen and (max-width: 600px) {
    width: 100%;
    padding-left: 70px;
    padding-right: 25px;
    left: 0;

    &::before {
      left: 60px;
      border: medium solid white;
      border-width: 10px 10px 10px 0;
      border-color: transparent white transparent transparent;
    }

    &::after {
      left: 15px;
    }
  }
`;

export const StyledContent = styled.div<{ connected: boolean }>`
  padding: 15px 15px;
  background-color: white;
  position: relative;
  border-radius: 6px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  h3 {
    margin-block-end: 0px;
    margin-block-start: 0px;
    color: ${(props) => (props.connected ? 'green' : 'red')};
  }
`;

export const DownloadFileButton = styled.button`
  background-color: ${({ theme }) => theme.colors.grey3};
  position: relative;
  cursor: pointer;
`;
